import { render, staticRenderFns } from "./editFeedback.vue?vue&type=template&id=18d84d54&"
import script from "./editFeedback.vue?vue&type=script&lang=js&"
export * from "./editFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports